export const C_DASHBOARD_CONSTANTS = {
  COST_SUMMARY: {
    PROJECT_COST_SUMMARY: "Project Cost Summary",
    ACTIVE_PROJECT: "Active Project",
    OVERDUE_INVOICE: "Overdue Invoice",
    PENDING_SUPPORT_REQ: "Pending Support Request",
    TOTAL_USER: "Total Users",
  },
  INVOICE_TO_PAID: {
    HEADER: "Invoice to be Paid",
    CURRENT: "Current ",
    OVERDUE_30: "Overdue by 30 days",
    OVERDUE_60: "Overdue by 60 days",
    OVERDUE_90: "Overdue by 90 days",
    OVERDUE_MORE_THAN_90: "Overdue by +90 days",
  },
  FINANCE_SUMMARY: {
    HEADER: "Finance Summary",
    INVOICED: "Invoiced",
    APPROVED: "Approved",
    PAID: "Paid",
    AWAITING_APPROVAL: "Awaiting Approval",
  },
  ADD_BTN: "View All",
  PROJECT_OVERVIEW: {
    TITLE: "Project Overview",
    EMPTY_SUBTITLE: "No Project found.",
  },
  SUPPORT_TICKET: {
    TITLE: "Support Ticket",
    EMPTY_SUBTITLE: "No Support Ticket found.",
  },
};
export const C_DASHBOARD_TOAST = {
  TABLE_UPDATE_SUCCESS: "Dashboard updated successfully.",
  PROJECT_UPDATE_SUCCESS: "Projects updated successfully.",
  WAREHOUSE_UPDATE_SUCCESS: "Warehousing data updated successfully.",
};
